import { render, staticRenderFns } from "./animacionPicker.vue?vue&type=template&id=3496eb60"
import script from "./animacionPicker.vue?vue&type=script&lang=js"
export * from "./animacionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports